export default "__VITE_ASSET__Dd9_e4_f__"